// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-msg{margin-bottom:125px}.form-msg p{font-size:28px;margin-bottom:40px;font-weight:500}@media (max-width: 767px){.form-msg{text-align:center}.form-msg h2{font-size:20px}.form-msg p{font-size:16px}.form-msg .btn{display:block;width:100%}}\n", ""]);
// Exports
module.exports = exports;
